{
  "cms.contentLocale.label": "Sisällön kieli",
  "cms.contentLocale.option.fi": "Suomi",
  "cms.contentLocale.option.sv": "Ruotsi",
  "cms.contentLocale.option.en": "Englanti",
  "cms.contentLocale.openRow.fi": "Tämä sisältö on suomeksi.",
  "cms.contentLocale.openRow.sv": "Tämä sisältö on ruotsiksi.",
  "cms.contentLocale.openRow.en": "Tämä sisältö on englanniksi.",
  "cms.contentLocale.preview.unavailable": "Esikatselu ei ole vielä käytettävissä tällä kielellä.",
  "cms.contentLocale.preview.empty": "Tällä kielellä ei ole vielä julkaistua sisältöä.",
  "cms.contentLocale.preview.selectedRowEmpty": "Tätä sisältöä ei ole valitulla kielellä."
}
